var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { DrawerButton, LayoutMenu, NavigationMenu } from '../../Layout/components';
import { DrawerWrapper, Footer, SectionName, Title, NavigationMenuWrapper, } from './styled';
import { SamoletLogo, CloseOutline } from '../../../components/Icon';
import { Logo } from '../../Layout/components/Logo';
var Drawer = function (_a) {
    var menu = _a.menu, logoUrl = _a.logoUrl, logoExtra = _a.logoExtra, logoToRoot = _a.logoToRoot, navigationMenuProps = _a.navigationMenuProps, menuProps = _a.menuProps, props = __rest(_a, ["menu", "logoUrl", "logoExtra", "logoToRoot", "navigationMenuProps", "menuProps"]);
    var onClose = function (e) {
        props.onClose && props.onClose(e);
    };
    var currentYear = new Date().getFullYear();
    return (React.createElement(DrawerWrapper, __assign({ width: 300, title: React.createElement(Title, null,
            React.createElement(DrawerButton, { icon: React.createElement(CloseOutline, { style: { fontSize: '24px' } }), onClick: onClose }),
            React.createElement(Logo, { root: logoToRoot, logoUrl: logoUrl },
                React.createElement(SamoletLogo, null),
                logoExtra)), placement: 'left', closeIcon: null }, props),
        React.createElement(SectionName, null, "\u041F\u0440\u043E\u0435\u043A\u0442"),
        React.createElement(LayoutMenu, __assign({ menu: menu }, menuProps)),
        React.createElement(SectionName, null, "\u041C\u0435\u043D\u044E"),
        React.createElement(NavigationMenuWrapper, null,
            React.createElement(NavigationMenu, __assign({}, navigationMenuProps, { mode: 'inline' }))),
        React.createElement(Footer, null,
            "Samolet Development \u00A9 ",
            currentYear)));
};
export default Drawer;
//# sourceMappingURL=Drawer.js.map